import api from './api';

const roomBase = (roomId) => `/api/rooms/${roomId}/challenges`;

const leagueBase = (roomId, leagueId) =>
  `/api/rooms/${roomId}/leagues/${leagueId}/challenges`;

const base = (roomId, leagueId) => leagueId ? leagueBase(roomId, leagueId) : roomBase(roomId);

export const getChallenges = async (roomId, leagueId = null) => {
  const response = await api.get(base(roomId, leagueId));
  return response.data;
};

export const getChallenge = async (roomId, leagueId, challengeId) => {
  const response = await api.get(`${base(roomId, leagueId)}/${challengeId}`);
  return response.data;
};

export const createChallenge = async (roomId, leagueId, data) => {
  const response = await api.post(base(roomId, leagueId), data);
  return response.data;
};

export const updateChallenge = async (roomId, leagueId, challengeId, data) => {
  const response = await api.put(`${base(roomId, leagueId)}/${challengeId}`, data);
  return response.data;
};

export const deleteChallenge = async (roomId, leagueId, challengeId, force = false) => {
  const params = force ? { force: true } : {};
  await api.delete(`${base(roomId, leagueId)}/${challengeId}`, { params });
};

export const updateChallengeStatus = async (roomId, leagueId, challengeId, data) => {
  const response = await api.patch(`${base(roomId, leagueId)}/${challengeId}/status`, data);
  return response.data;
};

export const getLeaderboard = async (roomId, leagueId, challengeId) => {
  const response = await api.get(`${base(roomId, leagueId)}/${challengeId}/leaderboard`);
  return response.data;
};

export const recalculateMainScores = async (roomId, leagueId, challengeId) => {
  const response = await api.post(`${base(roomId, leagueId)}/${challengeId}/main-score-backfill`);
  return response.data;
};

const sideBetBase = (roomId, leagueId, challengeId) => `${base(roomId, leagueId)}/${challengeId}/side-bets`;

export const getSideBets = async (roomId, leagueId, challengeId) => {
  const response = await api.get(sideBetBase(roomId, leagueId, challengeId));
  return response.data;
};

export const createSideBet = async (roomId, leagueId, challengeId, data) => {
  const response = await api.post(sideBetBase(roomId, leagueId, challengeId), data);
  return response.data;
};

export const updateSideBet = async (roomId, leagueId, challengeId, sideBetId, data) => {
  const response = await api.put(`${sideBetBase(roomId, leagueId, challengeId)}/${sideBetId}`, data);
  return response.data;
};

export const deleteSideBet = async (roomId, leagueId, challengeId, sideBetId) => {
  await api.delete(`${sideBetBase(roomId, leagueId, challengeId)}/${sideBetId}`);
};

export const deleteSideBetChoice = async (roomId, leagueId, challengeId, sideBetId) => {
  const response = await api.delete(`${sideBetBase(roomId, leagueId, challengeId)}/${sideBetId}/choice`);
  return response.data;
};

export const chooseSideBetOption = async (roomId, leagueId, challengeId, sideBetId, optionId) => {
  const response = await api.post(`${sideBetBase(roomId, leagueId, challengeId)}/${sideBetId}/choice`, { optionId });
  return response.data;
};

export const resolveSideBet = async (roomId, leagueId, challengeId, sideBetId, winningOptionId) => {
  const response = await api.patch(`${sideBetBase(roomId, leagueId, challengeId)}/${sideBetId}/resolve`, { winningOptionId });
  return response.data;
};
